
import { defineComponent } from 'vue';
import AdListItem from '@/ad/mixins/AdListItem';
import AdListGallery from './AdListGallery.vue';
import AdParams from './AdParams.vue';
import Banner from '../../shared/components/Banner.vue';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import { adService } from '../AdService';
import { mapGetters, mapState } from 'vuex';
import { GlobalState } from '@/shared/models/GlobalState';
import Modal from '@/shared/components/Modal.vue';
import AdViewsStatistics from './AdViewsStatistics.vue';
import Multiselect from 'vue-multiselect';
import config from '@/shared/constants/config';

export default defineComponent({
  mixins: [AdListItem],
  emits: ['publishChange', 'reservedChange', 'archivedChange'],
  props: {
    isBannerVisible: Boolean,
    isDeveloperProject: Boolean,
  },
  components: {
    AdListGallery,
    AdParams,
    ResizableImage,
    Modal,
    AdViewsStatistics,
    Multiselect,
    Banner,
  },
  data() {
    return {
      isEstateAgencyMode: config.IS_ESTATE_AGENCY_MODE,
      isInternalNoteOpen: false,
      isInternalNoteSaved: false,
      showChartModal: false,
      publishStatuses: ['publish', 'reserve', 'archive'],
      publishStatus: 'publish',
    };
  },
  created() {
    this.isInternalNoteOpen = !!this.ad.internalNote;
  },
  computed: {
    ...mapGetters(['isMobile']),
    ...mapState({
      user: (state) => (state as GlobalState).user,
    }),
    isEstateAgent() {
      return this.user && this.user.isEstateAgent;
    },
    isPublished(): boolean {
      return this.ad.isPublished && !this.ad.isBlocked;
    },
    landArea(): string {
      if (this.ad.estateType === 200 || this.ad.estateType === 300) {
        return (this.ad.landArea / 100).toLocaleString();
      } else {
        return '';
      }
    },
    classes() {
      const classes = (this as any).isPublished === false ? 'unpublished' : 'published';
      return classes + ' ' + this.classByAdType;
    },
    classByAdType(): string {
      switch (this.ad.adType) {
        case 1:
          return 'is-sale';
        case 2:
          return 'is-rent';
        case 3:
          return 'is-roommates';
      }
      return '';
    },
  },
  methods: {
    toggleInternalNote() {
      this.isInternalNoteOpen = !this.isInternalNoteOpen;
      if (this.isInternalNoteOpen) {
        this.$nextTick(() => {
          this.scrollToNote();
        });
      }
    },
    scrollToNote() {
      const el = this.$el.getElementsByClassName('estate-card__note')[0];
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    onPublishChanged() {
      this.$emit('publishChange', this.ad);
    },
    onReservedChanged() {
      this.$emit('reservedChange', this.ad);
    },
    onArchivedChanged() {
      this.$emit('archivedChange', this.ad);
    },
    async updateInternalNote() {
      try {
        await adService.updateInternalNote({ adId: this.ad.adId, internalNote: this.ad.internalNote });
        this.isInternalNoteSaved = true;
      } catch (error) {
        console.error(error);
      }
    },
  },
});
